import React from 'react';
import { Lock, CheckCircle2, ArrowRight, X } from 'lucide-react';
import { uiScale } from '../lib/uiScale';

interface SoftGateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLogin: () => void;
  onSignup: () => void;
}

const SoftGateModal: React.FC<SoftGateModalProps> = ({ isOpen, onClose, onLogin, onSignup }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-slate-900/60 backdrop-blur-md animate-[fadeIn_0.3s_ease-out_forwards]"
        onClick={onClose}
      ></div>

      <div className={`relative ${uiScale.modalPanel} ${uiScale.modalMaxHeight} animate-[scaleIn_0.3s_ease-out_forwards] flex flex-col`}>
        <button 
          onClick={onClose}
          className="absolute top-3 right-3 md:top-4 md:right-4 p-2 rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-900 transition-colors z-10"
        >
          <X size={20} />
        </button>

        <div className={`${uiScale.modalBody} text-center overflow-y-auto flex-1`}>
          <div className="size-12 md:size-16 bg-blue-50 rounded-xl md:rounded-2xl flex items-center justify-center mx-auto mb-4 md:mb-6 text-blue-600 shadow-sm transform rotate-3">
            <Lock size={24} className="md:w-8 md:h-8" />
          </div>
          
          <h2 className={`${uiScale.titleLg} mb-2 md:mb-3`}>
            Unlock Market Intelligence
          </h2>
          <p className={`${uiScale.body} mb-6 md:mb-8`}>
            You've hit the limit of our public preview. Create a free account to access full project data, AI analysis, and investment tools.
          </p>

          <div className="space-y-2 md:space-y-3 mb-6 md:mb-8 text-left bg-slate-50 p-4 md:p-5 rounded-2xl border border-slate-100">
             {[
               "View full payment plans & pricing",
               "Access AI comparative analysis",
               "Download floor plans & brochures",
               "Save properties to shortlist"
             ].map((item, i) => (
               <div key={i} className="flex items-center gap-3 text-sm font-medium text-slate-700">
                 <CheckCircle2 size={16} className="text-emerald-500 shrink-0" />
                 {item}
               </div>
             ))}
          </div>

          <div className="space-y-2 md:space-y-3">
            <button 
              onClick={onSignup}
              className={`w-full ${uiScale.button} bg-slate-900 hover:bg-slate-800 text-white shadow-lg shadow-slate-900/20 transition-all flex items-center justify-center gap-2 active:scale-95`}
            >
              Get Free Access <ArrowRight size={16} />
            </button>
            <button 
              onClick={onLogin}
              className={`w-full ${uiScale.button} bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 transition-all`}
            >
              Log In
            </button>
          </div>
        </div>
        
        <div className="bg-slate-50 p-3 md:p-4 text-center border-t border-slate-100">
           <p className="text-[10px] md:text-xs text-slate-400 font-medium">Trusted by 10,000+ investors</p>
        </div>
      </div>
    </div>
  );
};

export default SoftGateModal;